export const selectorForTourTarget = (target: string): string => `[data-tour="${target}"]`;

const isElementVisible = (element: Element): boolean => {
  let node: Element | null = element;
  while (node) {
    const style = window.getComputedStyle(node);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    node = node.parentElement;
  }
  return true;
};

/**
 * A closed antd Modal (or similar) stays mounted in the DOM, just hidden behind
 * `display: none` on an ancestor - a plain querySelector match can't tell a genuinely
 * open target from a stale, hidden one left over from before it was closed.
 */
export const findVisibleTourTarget = (target: string): Element | null => {
  const element = document.querySelector(selectorForTourTarget(target));
  return element && isElementVisible(element) ? element : null;
};
